import { Link } from 'react-router-dom';
import { ROUTES } from '@/app/routes';

export function NotFoundPage() {
  return (
    <section className="mx-auto max-w-2xl px-5 py-16 text-center">
      <p className="text-5xl font-bold text-primary">404</p>
      <h1 className="mt-3 text-xl font-semibold">没有找到这个页面</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        链接可能已失效，或者你输入的地址有误。
      </p>
      <Link
        to={ROUTES.home}
        className="mt-6 inline-block rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground hover:opacity-90"
      >
        回到首页
      </Link>
    </section>
  );
}
